import Navigation from '@/components/Navigation';

function TermsOfService() {
  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <Navigation />
      
      <div className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="font-['Outfit'] text-4xl font-bold mb-8">Terms of Service</h1>
        <div className="prose prose-invert max-w-none">
          <p className="text-gray-400 mb-8">Last Updated: February 1, 2026</p>

          <section className="mb-8">
            <h2 className="font-['Outfit'] text-2xl font-bold mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-300 mb-4">
              By accessing and using Negotiation Ninja AI ("the Service"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to these Terms of Service, please do not use the Service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-['Outfit'] text-2xl font-bold mb-4">2. Description of Service</h2>
            <p className="text-gray-300 mb-4">
              Negotiation Ninja AI provides AI-powered negotiation coaching, including roleplay simulations, script generation, and educational content. The Service uses artificial intelligence to help users practice and improve their negotiation skills.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-['Outfit'] text-2xl font-bold mb-4">3. User Accounts</h2>
            <p className="text-gray-300 mb-4">
              To access certain features, you must create an account using Google OAuth authentication. You are responsible for:
            </p>
            <ul className="list-disc list-inside text-gray-300 mb-4 space-y-2">
              <li>Maintaining the confidentiality of your account</li>
              <li>All activities that occur under your account</li>
              <li>Notifying us immediately of any unauthorized use</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="font-['Outfit'] text-2xl font-bold mb-4">4. Subscription Plans</h2>
            <p className="text-gray-300 mb-4">
              <strong>Free Plan:</strong> 3 AI roleplay sessions per month, basic features
            </p>
            <p className="text-gray-300 mb-4">
              <strong>Premium Plan (£7.99/month or £79/year):</strong> Unlimited roleplays, advanced features, priority support
            </p>
            <p className="text-gray-300 mb-4">
              Free trials last 3 days. Subscriptions automatically renew unless cancelled before the renewal date.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-['Outfit'] text-2xl font-bold mb-4">5. Payment Terms</h2>
            <ul className="list-disc list-inside text-gray-300 mb-4 space-y-2">
              <li>All fees are in GBP (£) and charged via Stripe</li>
              <li>Subscriptions auto-renew monthly or annually</li>
              <li>You may cancel anytime from your profile settings</li>
              <li>Refunds are provided within 30 days of purchase for annual plans</li>
              <li>Monthly subscriptions are non-refundable after the free trial period</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="font-['Outfit'] text-2xl font-bold mb-4">6. Acceptable Use</h2>
            <p className="text-gray-300 mb-4">You agree NOT to:</p>
            <ul className="list-disc list-inside text-gray-300 mb-4 space-y-2">
              <li>Use the Service for any illegal purpose</li>
              <li>Attempt to gain unauthorized access to the Service</li>
              <li>Share your account credentials with others</li>
              <li>Abuse, harass, or harm other users</li>
              <li>Scrape, copy, or redistribute Service content without permission</li>
              <li>Reverse engineer or attempt to extract source code</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="font-['Outfit'] text-2xl font-bold mb-4">7. Intellectual Property</h2>
            <p className="text-gray-300 mb-4">
              All content, features, and functionality of the Service are owned by Negotiation Ninja AI and are protected by international copyright, trademark, and other intellectual property laws.
            </p>
            <p className="text-gray-300 mb-4">
              You retain ownership of content you create (e.g., your negotiation scenarios), but grant us a license to use it to provide the Service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-['Outfit'] text-2xl font-bold mb-4">8. AI-Generated Content Disclaimer</h2>
            <p className="text-gray-300 mb-4">
              The AI-generated advice, scripts, and feedback are for educational purposes only. They do not constitute professional advice. Negotiation Ninja AI is not responsible for outcomes of real-world negotiations based on our AI recommendations.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-['Outfit'] text-2xl font-bold mb-4">9. Limitation of Liability</h2>
            <p className="text-gray-300 mb-4">
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, NEGOTIATION NINJA AI SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-['Outfit'] text-2xl font-bold mb-4">10. Cancellation and Termination</h2>
            <p className="text-gray-300 mb-4">
              You may cancel your subscription at any time from your profile settings. Upon cancellation:
            </p>
            <ul className="list-disc list-inside text-gray-300 mb-4 space-y-2">
              <li>You will retain access until the end of your billing period</li>
              <li>No refunds for partial months</li>
              <li>Your data will be retained for 90 days, then deleted</li>
            </ul>
            <p className="text-gray-300 mb-4">
              We reserve the right to terminate accounts that violate these Terms.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-['Outfit'] text-2xl font-bold mb-4">11. Changes to Terms</h2>
            <p className="text-gray-300 mb-4">
              We may modify these Terms at any time. Changes will be posted on this page with an updated "Last Updated" date. Continued use of the Service after changes constitutes acceptance of the new Terms.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-['Outfit'] text-2xl font-bold mb-4">12. Governing Law</h2>
            <p className="text-gray-300 mb-4">
              These Terms are governed by the laws of the United Kingdom. Any disputes will be resolved in the courts of England and Wales.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-['Outfit'] text-2xl font-bold mb-4">13. Contact Us</h2>
            <p className="text-gray-300 mb-4">
              For questions about these Terms, please contact us at:
            </p>
            <p className="text-gray-300">
              Email: guniboparai@gmail.com<br />
              Website: https://ninjaninja.co
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default TermsOfService;